import { all } from 'redux-saga/effects';
import { nftSagaWatcher } from './nft/sagas';
import { transactionsSagaWatcher } from './transactions/sagas';

export function* rootSaga(): Generator {
  yield all([nftSagaWatcher(), transactionsSagaWatcher()]);
}
